import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgProfile = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M12 4.85a4.675 4.675 0 1 0 0 9.35 4.675 4.675 0 0 0 0-9.35M8.975 9.525a3.025 3.025 0 1 1 6.05 0 3.025 3.025 0 0 1-6.05 0"
        clipRule="evenodd"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M12 1a11 11 0 1 0 0 22 11 11 0 0 0 0-22M8.422 3.362a9.35 9.35 0 0 1 10.902 14.45c-1.818-1.486-4.448-2.237-7.324-2.237s-5.506.75-7.324 2.238A9.35 9.35 0 0 1 8.422 3.362M5.817 19.013a9.35 9.35 0 0 0 12.366 0c-1.438-1.127-3.613-1.788-6.183-1.788s-4.745.66-6.183 1.788"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgProfile;
